import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTHORIZATION_KEY, AuthorizationPartialState, State } from './authorization.reducer';

export const getAuthorizationState = createFeatureSelector<State>(AUTHORIZATION_KEY);

export const getPermissions = createSelector(
  getAuthorizationState,
  (state: State) => state.permissions
);

export const getIsPermissionsLoaded = createSelector(
  getAuthorizationState,
  (state: State) => state.isPermissionsLoaded
);

export const getIsLoading = createSelector(
  getAuthorizationState,
  (state: State) => state.isLoading
);

export const authorizationQuery = {
  getAuthorizationState,
  getPermissions,
  getIsLoading,
  getIsPermissionsLoaded
};
